/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Range_VisibleInputs */

const cs_calendar_range_visible = /** @type {(inputs: Calendar_Range_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viditelný rozsah`)
};

const en_calendar_range_visible = /** @type {(inputs: Calendar_Range_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visible range`)
};

/**
* | output |
* | --- |
* | "Visible range" |
*
* @param {Calendar_Range_VisibleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_range_visible = /** @type {((inputs?: Calendar_Range_VisibleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Range_VisibleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_range_visible(inputs)
	return cs_calendar_range_visible(inputs)
});